import $axios from '@/api/apiPublic';

const getCourses = async () => {
  const response = await $axios.get('articles/courses');
  return response;
};

const getCourse = async id => {
  const response = await $axios.get(`articles/courses/${id}`);
  return response;
};

const getArticle = async id => {
  const response = await $axios.get(`articles/courses/article/${id}`);
  return response;
};

export default {
  getCourses,
  getCourse,
  getArticle,
};
